/**
 * AdminAuthContext — Admin App
 * Authenticates against the Spring Boot API.
 * Verifies returned role is ADMIN before allowing access.
 */
import React, { createContext, useContext, useState, useEffect } from 'react';
import { loginUser, logoutUser, isAuthenticated } from '../api';

const AdminAuthContext = createContext();

export function AdminAuthProvider({ children }) {
  const [admin,   setAdmin]   = useState(null);
  const [loading, setLoading] = useState(true);

  /* ── Restore session ── */
  useEffect(() => {
    const stored = localStorage.getItem('ae_admin');
    if (stored && isAuthenticated()) {
      try { setAdmin(JSON.parse(stored)); } catch {}
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      const result = await loginUser({ email, password });
      if (!result?.user) return { success: false, error: 'Login failed.' };
      if (result.user.role !== 'ADMIN') {
        return { success: false, error: 'Access denied — admin accounts only.' };
      }
      setAdmin(result.user);
      localStorage.setItem('ae_admin', JSON.stringify(result.user));
      return { success: true };
    } catch (e) {
      const msg = e.response?.data?.message || 'Invalid email or password.';
      return { success: false, error: msg };
    }
  };

  const logout = () => {
    logoutUser();
    setAdmin(null);
    localStorage.removeItem('ae_admin');
  };

  return (
    <AdminAuthContext.Provider value={{ admin, loading, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthContext);